import React from "react";
import { howItWorks } from "../mock";
import Reveal from "./Reveal";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative py-24 md:py-32 bg-[#f7f3ea]">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-16">
            <p className="font-mono-eyebrow text-[#486a8f] mb-4">How it works</p>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] text-[#0f1724] tracking-tight">
              Three steps to{" "}
              <span className="italic font-light text-[#486a8f]">daily clarity</span>
            </h2>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {howItWorks.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.12}>
              <div className="relative h-full rounded-2xl bg-white border border-[#eadfc9] p-8 md:p-10 card-hover">
                <div className="flex items-start justify-between mb-8">
                  <span className="font-display text-[56px] leading-none text-[#486a8f]">
                    {step.number}
                  </span>
                  <span className="font-mono-eyebrow text-[#9aa3ae]">Step</span>
                </div>
                <h3 className="font-display text-[26px] md:text-[28px] text-[#0f1724] tracking-tight mb-4 leading-tight">
                  {step.title}
                </h3>
                <p className="font-body text-[15px] leading-relaxed text-[#4b5563]">
                  {step.description}
                </p>
                <div className="mt-8 h-px bg-gradient-to-r from-[#e9e0cd] via-[#cbd5e1] to-transparent" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
